module.exports = __webpack_public_path__ + "assets/4c87ecaa43d96545b44feb6d2a470590.png";